<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-课件-添加
    -->
  <el-dialog
      title="添加课件"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
  >

    <div class="product-add pb50">

      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <div class="common-form">添加课件</div>
        
        <el-form-item label="课件名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入课件名称" class="max-w460"></el-input>
        </el-form-item>
        <el-form-item label="课件封面：" prop="cover_img">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.cover_img">
              <transition-group>
                <div v-for="(item, index) in form.cover_img" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        
        <el-form-item label="所属组织" prop="ma_company_id">
          <el-select 
            v-model="form.ma_company_id" 
            placeholder="请选择所属组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in organizationList"
              :key="dept.ma_company_id"
              :label="dept.name"
              :value="dept.ma_company_id"
            />
          </el-select>
        </el-form-item>
        
        <!-- 所属行业：多选级联 -->
        <el-form-item label="所属行业" prop="industry_id">
          <el-cascader
            v-model="form.industry_id"
            :options="industryTree"
            :props="industryCascaderProps"
            placeholder="请选择所属行业（可多选）"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('industry_id', $event)"
          ></el-cascader>
        </el-form-item>

        <!-- 培训类别：多选级联 -->
        <el-form-item label="培训类别" prop="class_id">
          <el-cascader
            v-model="form.class_id"
            :options="classTree"
            :props="classCascaderProps"
            placeholder="请选择培训类别（可多选）"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('class_id', $event)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="课件目录" prop="directory_id">
          <el-cascader
            v-model="form.directory_id"
            :options="directoryTree"
            :props="directoryCascaderProps"
            placeholder="请选择目录"
            style="width: 100%;"
            clearable
            filterable
            @change="handleCascaderChange('directory_id', $event)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="课件分类" prop="courseware_category_id">
          <el-select 
            v-model="form.courseware_category_id" 
            placeholder="请选择所属分类"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in categoryList"
              :key="dept.courseware_category_id"
              :label="dept.name"
              :value="dept.courseware_category_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="视频上传" prop="annex_file" required>
          <el-button icon="el-icon-video-camera" @click="openFileUpload">选择视频</el-button>
          <span style="color: #909399; font-size: 12px; margin-left: 8px;">支持 mp4、webm 等格式</span>
          <div v-if="uploadStatus === 'success'" style="color: #67C23A; font-size: 12px; margin-top: 5px;">
            {{ form.annex_file }}
          </div>
          <div v-if="uploadStatus === 'error'" style="color: #F56C6C; font-size: 12px; margin-top: 5px;">
            视频上传失败，请重新上传
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      <!--业务附件上传组件-->
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
      </Upload>
      <Upload v-if="isuploadFile" :isupload="isuploadFile" :config="{ accept: 'video' }" @returnImgs="returnFilesFunc">上传视频</Upload>
    </div>
  </el-dialog>

</template>

<script>
import CoursewareApi from '@/api/courseware.js';
import Ma_companyApi from '@/api/ma_company.js';
import AfuncApi from '@/api/afunc.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload: Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      isuploadFile:false,
      organizationList: [],
      categoryList: [],
      isupload: false,
      isImg: false,
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      // 无限级树形数据
      industryTree: [],
      classTree: [],
      directoryTree: [],
      // 行业多选配置
      industryCascaderProps: {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_industry_id',
        label: 'name',
        children: 'children',
        emitPath: true,
        collapseTags: false,
        clearable: true
      },
      directoryCascaderProps: {
        multiple: false,
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_directory_id',
        label: 'name',
        children: 'children',
        emitPath: true,
        collapseTags: false,
        clearable: true
      },
      // 类别多选配置
      classCascaderProps: {
        multiple: true,
        checkStrictly: true,
        expandTrigger: 'click',
        value: 'courseware_class_id',
        label: 'name',
        children: 'children',
        emitPath: true,
        collapseTags: false,
        clearable: true
      },
      form: {
        name: '',
        sort: 50,
        industry_id: [],
        directory_id:'',
        class_id: [],
        ma_company_id: '',
        courseware_category_id:'',
        image: [],
        cover_img:[],
        bannar: [],
        intro: '',
        annex_file:''
      },
      loading: false,
      // 表单验证
      rules: {
        name: [{ required: true, message: '请输入课件名称', trigger: 'blur' }],
        ma_company_id: [{ required: true, message: '请选择所属组织', trigger: 'blur' }],
        
        industry_id: [{ 
          required: true, 
          message: '请选择所属行业', 
          trigger: 'change', 
          type: 'array',
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请选择所属行业'));
            } else {
              callback();
            }
          }
        }],
        class_id: [{ 
          required: true, 
          message: '请选择培训类别', 
          trigger: 'change', 
          type: 'array',
          validator: (rule, value, callback) => {
            if (!value || value.length === 0) {
              callback(new Error('请选择培训类别'));
            } else {
              callback();
            }
          }
        }],
        courseware_category_id: [{ required: true, message: '请选择所属课件分类', trigger: 'blur' }],
        directory_id: [{ required: true, message: '请选择所属课件分类', trigger: 'blur' }],
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album",
      uploadStatus: '',
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    // 初始化加载树形数据
    this.getTree('courseware_industry');
    this.getTree('courseware_class');
    this.getTree('courseware_directory');
    this.loadOrganization();
    this.loadCategory();
  },
  props: ["open_add"],
  methods: {
    openFileUpload() {
      this.isuploadFile = true;
    },
    returnFilesFunc(e) {
      this.uploadStatus = ''
      if (e != null && e.length > 0) {
        this.form.annex_file = e[0].file_path;
        this.uploadStatus = 'success'
        this.isFileUploaded = true;
        this.$nextTick(() => {
          this.$refs.form.validateField('annex_file')
        })
      }
      this.isuploadFile = false;
    },
    async loadCategory() {
      try {
        const response = await AfuncApi.call({
          model: 'courseware_category',
          action: 'getList',
          page:1,
          list_rows:1000
        });
        
        if (!response) {
          this.categoryList = [];
          return;
        }
        if (response.code === 1 && response.data.list) {
          this.categoryList = response.data.list.data || [];
        } else {
          this.categoryList = [];
        }
      } catch (error) {
        this.categoryList = [];
      }
    },
    // 加载组织列表
    async loadOrganization() {
      try {
        const response = await Ma_companyApi.list({}, true);
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.organizationList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list) {
          this.organizationList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.organizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.organizationList = [];
      }
    },

    // 加载树形数据
    getTree: async function(table) {
      try {
        var response = await AfuncApi.call({
          model: 'courseware_directory',
          action: 'getInfiniteTree',
          type: table,
        });
        if (response.code === 1) {
          if (table === 'courseware_industry') {
            this.industryTree = response.data.list || [];
          } else if (table === 'courseware_class') {
            this.classTree = response.data.list || [];
          } else if (table === 'courseware_directory') {
            this.directoryTree = response.data.list || [];
          }
        } else {
          this.$message.error(response.msg || '加载数据失败');
        }
      } catch (error) {
        console.error('加载' + table + '树形数据失败:', error);
        this.$message.error('加载分类数据失败，请稍后重试');
      }
    },

    // 处理级联选择器变化（父子互斥逻辑）
    handleCascaderChange: function(field, selectedArr) {
      if (!Array.isArray(selectedArr) || selectedArr.length === 0) {
        this.$set(this.form, field, []);
        return;
      }
      
      var selectCopy = JSON.parse(JSON.stringify(selectedArr));
      var finalSelect = [];
      
      selectCopy.sort((a, b) => a.length - b.length);
      
      for (var i = 0; i < selectCopy.length; i++) {
        var currentPath = selectCopy[i];
        var isChild = false;
        
        for (var j = 0; j < finalSelect.length; j++) {
          var existingPath = finalSelect[j];
          
          if (currentPath.length > existingPath.length) {
            var isPrefix = true;
            for (var k = 0; k < existingPath.length; k++) {
              if (currentPath[k] !== existingPath[k]) {
                isPrefix = false;
                break;
              }
            }
            if (isPrefix) {
              isChild = true;
              break;
            }
          }
        }
        
        if (!isChild) {
          finalSelect.push(currentPath);
        }
      }
      
      this.$set(this.form, field, finalSelect);
    },

    chooseCategory() {
      this.iscategorya = true;
    },
    
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false, "type": "" });
    },

    // 取消
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    // 提交表单
    async onSubmit() {
      try {
        // 表单验证
        await this.$refs.form.validate();
      } catch (err) {
        console.log('表单验证失败:', err);
        return;
      }
      
      this.loading = true;

      // 处理多选值：二维数组 → 逗号分隔字符串（取最后一级ID）
      var handleMultiple = function(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return '';
        var ids = [];
        for (var i = 0; i < arr.length; i++) {
          if (Array.isArray(arr[i]) && arr[i].length > 0) {
            ids.push(arr[i][arr[i].length - 1]);
          }
        }
        return ids.join(',');
      };
      
      // 处理单选值：一维数组 → 最后一级ID
      var handleSingle = function(arr) {
        if (!Array.isArray(arr) || arr.length === 0) return 0;
        return arr[arr.length - 1];
      };
      // 构造提交数据
      var formData = {
        name: this.form.name,
        sort: this.form.sort || 50,
        courseware_industry_id: handleMultiple(this.form.industry_id),
        courseware_directory_id: handleSingle(this.form.directory_id),
        courseware_class_id: handleMultiple(this.form.class_id),
        ma_company_id: this.form.ma_company_id,
        courseware_category_id: this.form.courseware_category_id,
        cover_img: this.form.cover_img,
        annex_file: this.form.annex_file,
      };

      // 如果有富文本编辑器内容，获取内容
      if (this.$refs.ue) {
        formData.intro = this.$refs.ue.getUEContent();
      }

      try {
        // 使用CoursewareApi.add方法
        const response = await CoursewareApi.add(formData, true);
        
        if (response.code === 1) {
          this.$message.success(response.msg || '添加课件成功');
          this.dialogFormVisible('success');
          // 清空表单
          this.$refs.form.resetFields();
          this.form.sort = 50;
          this.form.industry_id = [];
          this.form.directory_id = [];
          this.form.class_id = [];
          this.ueditor.text = '';
        } else {
          this.$message.error(response.msg || '添加课件失败');
        }
      } catch (error) {
        console.error('添加课件失败:', error);
        this.$message.error('添加课件失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },

    /*打开上传图片*/
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if (!e || e.length === 0) return;
      
      let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
      let isLegal = true;
      
      for (let i = 0; i < e.length; i++) {
        let element = e[i];
        let filePath = element.file_path || '';
        let ext = filePath.split(".").pop() || '';
        if (imgExpt.indexOf(ext.toLowerCase()) === -1) {
          isLegal = false;
          break;
        }
      }
      
      if (!isLegal) {
        this.$message.error("图片类型有误，请选择bmp/jpg/jpeg/png/gif格式");
        return false;
      }
      let imgs = this.form.cover_img ? this.form.cover_img.concat(e) : e;
      this.$set(this.form, "cover_img", imgs);
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index) {
      this.form.cover_img.splice(index, 1);
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.common-form {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}
.max-w460 {
  max-width: 460px;
  width: 100%;
}
.common-button-wrapper {
  margin-top: 20px;
  text-align: center;
}
.pb50 {
  padding-bottom: 50px;
}
</style>

<style>
/* 多选级联组件样式优化 */
.el-cascader__tags {
  flex-wrap: wrap !important;
  white-space: normal !important;
  min-height: 32px;
  line-height: normal;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.el-cascader__tag {
  margin: 2px 4px 2px 0 !important;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-cascader__input {
  min-height: 32px !important;
  line-height: 32px !important;
  padding: 0 12px !important;
}

.el-cascader__search-input {
  min-height: 30px !important;
}

.el-cascader__dropdown {
  max-height: 400px !important;
  overflow-y: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/courseware/index/part/add.vue